/** @format */

import {Box, InputLabel, Popover, Select, Typography} from '@mui/material';
import type {Theme} from '@mui/material/styles';
import {styled} from '@mui/material/styles';

export const StyledPopover = styled(Popover)(({theme}) => ({
  '& .MuiPaper-root': {
    padding: theme.spacing(4),
    minWidth: 560,
    backgroundColor: theme.palette.secondary.main,
  },
}));

export const Title = styled(Typography)(({theme}) => ({
  marginBottom: theme.spacing(2),
  color: theme.palette.text.secondary,
  fontSize: '16px',
  fontWeight: 400,
}));

export const Row = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
}));

export const Divider = styled(Typography)(({theme}) => ({
  opacity: 0.6,
  color: theme.palette.text.secondary,
}));

export const Multiply = styled(Typography)(({theme}) => ({
  color: theme.palette.text.secondary,
  marginLeft: theme.spacing(1),
  whiteSpace: 'nowrap',
}));

export const Actions = styled(Box)(({theme}) => ({
  marginTop: theme.spacing(2),
  display: 'flex',
  justifyContent: 'flex-start',
}));

export const StyledSelect = styled(Select)(({theme}) => ({
  width: '100%',
  color: theme.palette.text.secondary,
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(2),
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.figma_gray_middle?.main,
  },
  '& .MuiSelect-nativeInput': {
    padding: theme.spacing(2, 4),
  },
}));

export const StyledInputLabel = styled(InputLabel)(({theme}) => ({
  top: '-8px',
  color: `${theme.palette.text.secondary} !important`, // Important because of MUI styles override priority by specificity selector
}));

export const getSelectMenuPaperSx = (theme: Theme) => ({
  backgroundColor: theme.palette.common.white,
});

export const getSelectMenuListSx = (theme: Theme) => ({
  '& .MuiMenuItem-root': {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.secondary,
    opacity: 1,
    transition: 'none',
    '&:hover': {
      backgroundColor: theme.palette.figma_gray_light_0?.main,
      color: theme.palette.text.secondary,
    },
    '&.Mui-focusVisible': {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.text.secondary,
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.text.secondary,
    },
    '&.Mui-selected:hover': {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.text.secondary,
    },
  },
});
